module.exports = __webpack_public_path__ + "img/semiRing5.13c80000.svg";